module.exports = __webpack_public_path__ + "static/media/0323_IMG_FE_LES_MURS_PAPIER_BRIQUE_BLANCHE.75a444c0.png";